import styled from 'styled-components'
import Grid from '@material-ui/core/Grid'

export const Footer = styled.div`
  margin-top: 10px;

  a {
    font-weight: bold;
    color: ${({theme}) => theme.SECONDARY_COLOR};
  }
`;

export const FooterHeading = styled(Grid)`
  font-size: 14px;
  padding: 10px 10px;
  margin-bottom: 10px;
  background-color: #383838;
  color: ${({theme, isactive}) => isactive === 'true' ? theme.WARNING : 'white'};
  cursor: pointer;

  img {
    height: 22px;
    margin-right: 10px;
  }
`

export const Content = styled.div`
  font-size: 14px;
  padding: 5px 10px 15px;
  text-align: justify;
  max-width: 1200px;
  margin: 0 auto;
  background-color: white;
`;
